export default __webpack_public_path__ + "static/media/add-giver.60f8e2cc.png";